<template>
	<v-row class="pt-8 pb-8 mr-2">
		<v-spacer />

		<v-tooltip top v-if="promo.status">
			<template v-slot:activator="{ on }">
				<v-btn v-on="on" class="mr-4" elevation="2" @click="openStatusModal">
					Status
					<v-icon dense right>
						{{ (readOnlyPromo && !isPromoStatusAdmin) ? 'mdi-view-headline' : 'mdi-pencil' }}
					</v-icon>
				</v-btn>
			</template>
			<span>{{ (readOnlyPromo && !isPromoStatusAdmin) ? 'View Status' : 'Update Status' }}</span>
		</v-tooltip>

		<v-tooltip top v-if="promo.id && showVendorApproval">
			<template v-slot:activator="{ on }">
				<v-btn v-on="on" class="mr-4" elevation="2" @click="openVendorApprovalModal">
					Approval
					<v-icon dense right>
						mdi-account-check
					</v-icon>
				</v-btn>
			</template>
			<span>Vendor Approval</span>
		</v-tooltip>

		<v-tooltip top v-if="showContractDownloadButton">
			<template v-slot:activator="{ on }">
				<v-btn v-on="on" elevation="2" class="mr-4" @click="downloadContract">
					Contract
					<v-icon dense right>
						mdi-file-download
					</v-icon>
				</v-btn>
			</template>
			<span>Download Contract</span>
		</v-tooltip>

		<v-tooltip top v-if="showShuttleButton && !readOnlyPromo">
			<template v-slot:activator="{ on }">
				<v-btn v-on="on" color="#222" elevation="2" class="mr-4 white--text" @click="openShuttleModal">
					Shuttle
					<v-icon dense right>mdi-bus-multiple</v-icon>
				</v-btn>
			</template>
			<span>Shuttle Promo</span>
		</v-tooltip>

		<v-tooltip top v-if="promo.id && isPromoVendorAdmin">
			<template v-slot:activator="{ on }">
				<v-btn v-on="on" elevation="2" class="mr-4" @click="downloadPromo">
					Download
					<v-icon dense right>
						mdi-download
					</v-icon>
				</v-btn>
			</template>
			<span>Download Promo</span>
		</v-tooltip>

		<v-tooltip top v-if="promo.id && hasWriteAccess && isPromoVendorAdmin">
			<template v-slot:activator="{ on }">
				<v-btn :disabled="itemsDisabled" v-on="on" elevation="2" class="mr-4" @click="openCloneModal">
					Copy
					<v-icon dense right>mdi-plus-box-multiple-outline</v-icon>
				</v-btn>
			</template>
			<span>Copy Promo</span>
		</v-tooltip>

		<v-tooltip top v-if="showComplexMerging">
			<template v-slot:activator="{ on }">
				<v-btn :loading="saving" :disabled="saving" v-on="on" elevation="2" class="mr-4" @click="openComplexMergingModal">
					Merge Complex
					<v-icon dense right>mdi-vector-union</v-icon>
				</v-btn>
			</template>
			<span>Merge Complex Promo</span>
		</v-tooltip>

		<v-tooltip top v-if="showMergedPromos">
			<template v-slot:activator="{ on }">
				<v-btn :loading="saving" :disabled="saving" v-on="on" elevation="2" class="mr-4" @click="openMergedPromosModal">
					Merged Promos
					<v-icon dense right>mdi-vector-difference</v-icon>
				</v-btn>
			</template>
			<span>View Promos Included in Merge</span>
		</v-tooltip>

		<v-tooltip top v-if="!readOnlyPromo || promoNameEditException || !enabledInApprovedStatus">
			<template v-slot:activator="{ on }">
				<v-btn :loading="saving" :disabled="saving || value != 0" v-on="on" elevation="2" color="green" class="mr-2 white--text"
					@click="savePromo">
					{{ (id) ? 'Update' : 'Save' }}
					<v-icon dense right>
						{{ (id) ? 'mdi-update' : ' mdi-content-save-outline' }}
					</v-icon>
				</v-btn>
			</template>
			<span>{{ (id) ? 'Update' : 'Create' }} Promo</span>
		</v-tooltip>

		<v-tooltip top v-if="id && hasScope('promo:delete') && !readOnlyPromo">
			<template v-slot:activator="{ on }">
				<v-btn elevation="2" v-on="on" color="red" class="white--text mx-1" @click="openConfirmationModal">
					Delete
					<v-icon dense right>mdi-trash-can-outline</v-icon>
				</v-btn>
			</template>
			<span>Delete Promo</span>
		</v-tooltip>
	</v-row>
</template>
<script>
import { userAccess } from '@/mixins/user-access'

export default {
  name: 'PromoActions',
	props: [
		'value',
		'id',
		'readOnlyPromo',
		'showContractDownloadButton',
		'isPromoStatusAdmin',
        'showVendorApproval',
		'showShuttleButton',
		'showComplexMerging',
		'showMergedPromos',
		'itemsDisabled',
		'promo',
		'saving',
		'isPromoVendorAdmin',
		'promoNameEditException',
		'enabledInApprovedStatus'
	],
	methods: {
		openCloneModal() {
			this.$emit('openCloneModal')
		},
		openShuttleModal() {
			this.$emit('openShuttleModal')
		},
		openStatusModal() {
			this.$emit('openStatusModal')
		},
        openVendorApprovalModal() {
            this.$emit('openVendorApprovalModal')
        },
		openConfirmationModal() {
			this.$emit('openConfirmationModal')
		},
		openComplexMergingModal () {
			this.$emit('openComplexMergingModal')
		},
		openMergedPromosModal () {
			this.$emit('openMergedPromosModal')
		},
		downloadContract() {
			this.$emit('downloadContract')
		},
		downloadPromo() {
			this.$emit('downloadPromo')
		},
		savePromo() {
			this.$emit('savePromo')
		}
	},
	mixins: [userAccess],
}
</script>